import Vue from "vue";
import Url from "./url";
import Moment from "moment";

class LogHelper {
  constructor() {
    let url = new Url();
    let loglevel = url.get("loglevel");

    if (loglevel) loglevel = loglevel.toUpperCase();

    this.log("INFO", "Log", `loglevel: ${loglevel}`);

    this.hasLogDebug = false;
    this.hasLogInfo = false;
    this.hasLogWarning = false;
    this.hasLogError = false;

    switch (loglevel) {
      case "DEBUG":
        this.hasLogDebug = true;
        break;
      case "INFO":
        this.hasLogInfo = true;
        break;
      case "WARNING":
        this.hasLogWarning = true;
        break;
      default:
        this.hasLogError = true;
        break;
    }
  }

  async logDebug(src, msg) {
    if (!this.hasLogDebug) {
      return;
    }
    await this.log("Debug", src, msg);
  }

  async logInfo(src, msg) {
    if (!this.hasLogInfo) {
      return;
    }
    await this.log("Info", src, msg);
  }

  async logWarning(src, msg) {
    if (!this.hasLogWarning) {
      return;
    }
    await this.log("Warning", src, msg);
  }

  async logError(src, msg, err, moduleName) {
    if (!this.hasLogError) {
      return;
    }
    await this.log("Error", src, `${msg}: ${err}`);

    let date = Moment().format();
    this.setLog("Next Log", moduleName, date, "Error", src, `${msg}: ${err}`);
  }

  async log(type, src, msg) {
    let date = Moment().format();
    Vue.$log.info(`${date}[${type}][${src}] ${msg}`);
  }

  /*Logs*/
  setLog(key, moduleName, date, type, src, msg) {
    try {
      if ("serviceWorker" in navigator) {
        if (navigator.serviceWorker.controller == null) {
          return Promise.reject("No service worker controller for logs.");
        }
        return new Promise(function(resolve, reject) {
          var messageChannel = new MessageChannel();
          messageChannel.port1.onmessage = function(event) {
            if (event.data.error) {
              reject(event.data.error);
            } else {
              resolve(event.data);
            }
          };

          let urlLog = new Url().url;
          let message = {
            key: key,
            msg: {
              Module: moduleName,
              Date: date,
              Level: type,
              Url: urlLog,
              SourceContext: src,
              Message: msg
            }
          };
          navigator.serviceWorker.controller.postMessage(message, [messageChannel.port2]);
        });
      } else {
        return Promise.reject("No service worker for logs.");
      }
    } catch (error) {
      Vue.$log.error(`SetLog LocalStorage error ` + error);
    }
  }
}

export default LogHelper;
